import PropTypes from "prop-types"
import React from "react"

const InsightCard = ({ icon, title, value, description }) => (
  <div className="flex flex-col gap-1 rounded-lg bg-gradient-to-br from-blue-50 to-supplementary-violet-200 p-4">
    <div className="flex items-center gap-2">
      <i className={`icon ${icon} text-lg text-blue-700`} />
      <span className="text-sm">{title}</span>
    </div>
    <span className="text-xl font-semibold">{value}</span>
    <span className="text-xs text-gray-700">{description}</span>
  </div>
)

InsightCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  description: PropTypes.string.isRequired,
}

export default InsightCard
